import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
// eslint-disable-next-line no-unused-vars
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'status', sortable: true },
    { key: 'occured_on', sortable: true, thStyle: { width: '150px' } },
    { key: 'area', sortable: true },
    { key: 'machine', sortable: true },
    { key: 'trouble', sortable: true },
    { key: 'remarks', sortable: true },
    { key: 'closed_on', sortable: true },
    { key: 'nama', label: 'Reported By', sortable: true },
    { key: 'update_time', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('occured_on')
  const isSortDirDesc = ref(false)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter], () => {
    refetchData()
  })

  const fetchData = (ctx, callback) => {
    store
      .dispatch('app-user/fetchData', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        group_item: roleFilter.value,
      })
      .then(response => {
        // const { users, total } = response.data

        callback(response.data.data)
        totalData.value = response.data.count
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = []

  const resolveUserRoleIcon = status => {
    if (status === 'Open') return 'UnlockIcon'
    if (status === 'Close') return 'LockIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'Open') return 'danger'
    if (status === 'Close') return 'success'
    return 'primary'
  }

  // taskLocal
  // ------------------------------------------------
  const taskLocal = ref([])
  const resetTaskLocal = () => {
    taskLocal.value = []
  }
  // watch(props.task, () => {
  //   resetTaskLocal()
  // })

  return {
    taskLocal,
    resetTaskLocal,

    fetchData,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
